import { Plus } from 'lucide-react';
import { EmptyState } from '@/shared/components';

interface Props {
  kind: 'error' | 'filtered' | 'empty';
  onResetFilters: () => void;
  onInvite: () => void;
}

/**
 * Die drei Leerzustände der Benutzerliste.
 *
 * <p>Sie unterscheiden sich in der einen realen nächsten Aktion (§11): ein leeres Ergebnis nach
 * einer Suche braucht den Weg zurück zum vollen Bestand, ein wirklich leerer Workspace die
 * Einladung. Ein gemeinsamer Text wäre in beiden Fällen der falsche Rat.</p>
 */
export function UsersEmptyState({ kind, onResetFilters, onInvite }: Props) {
  if (kind === 'error') {
    return (
      <EmptyState
        icon="Error"
        title="Die Benutzer konnten nicht geladen werden"
        description="Bitte laden Sie die Seite neu. Bleibt es dabei, ist der Dienst gerade nicht erreichbar."
      />
    );
  }

  if (kind === 'filtered') {
    return (
      <EmptyState
        icon="Users"
        title="Keine Benutzer für diese Auswahl"
        description="Weder Suchbegriff noch Rolle oder Zustand treffen ein Konto in diesem Workspace."
        action={{ label: 'Filter zurücksetzen', onClick: onResetFilters }}
      />
    );
  }

  return (
    <EmptyState
      icon="Users"
      title="Noch keine Benutzer"
      description="Laden Sie den ersten Benutzer ein — er bekommt eine Einladung per E-Mail."
      action={{
        label: 'Benutzer einladen',
        leftIcon: <Plus size={14} aria-hidden />,
        onClick: onInvite,
      }}
    />
  );
}
